<ion-toolbar color="light" class="page-sub-header" style="margin-bottom: 1rem;">
  <ion-buttons slot="start" *ngIf="legend.config.showCancel">
    <ion-button fill="clear" (click)="cancel()">{{legend.config.cancelLabel}}</ion-button>
  </ion-buttons>

  <ion-title class="ion-text-center">{{legend.title}}</ion-title>

  <ion-buttons slot="end" *ngIf="legend.config.showOk">
    <ion-button fill="clear" color="primary" (click)="ok()">{{legend.config.okLabel}}</ion-button>
  </ion-buttons>
</ion-toolbar>
<ion-content>
  <ion-grid class="ion-padding">
    <ion-row class="result-row" *ngIf="legend.config.disclaimer">
      <ion-col class="ion-text-center">
        <ion-label color="danger">*DISCLAIMER: {{legend.config.disclaimer}}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row class="header-row" *ngIf="legend.config.showHeaderRow">
      <ng-container *ngFor="let header of legend.headers">
        <ion-col [size]="header.size">{{ header.label }}</ion-col>
      </ng-container>
    </ion-row>
    <ion-row class="result-row" *ngFor="let item of legend.items">
      <ion-col [size]="item.termColumnSize"><ion-label>{{ item.term }}</ion-label></ion-col>
      <ion-col [size]="item.definitionColumnSize"><ion-label>{{ item.definition }}</ion-label></ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
